import { Button, Col, Form, Input, Row, Table } from 'antd';
import { useEffect, useState } from 'react';
import {
  ArchiveAnnualCollaborationDocuments,
  GetStudyYears,
  UpdateCurrentStudyYear,
} from '../helper/apiHelper';
import { t } from 'i18next';
import type { ReducedStudyYear } from '../Types/interfaces';
import { formatDate } from '../Utils/date';

export const StudyYearComponent = () => {
  const [dataSource, setDataSource] = useState<Array<any>>([]);
  const [form] = Form.useForm();

  const columns = [
    {
      title: t('studyYear.startDate'),
      dataIndex: 'startDate',
      key: 'startDate',
    },
    {
      title: t('studyYear.endDate'),
      dataIndex: 'endDate',
      key: 'endDate',
    },
    {
      title: t('studyYear.state'),
      dataIndex: 'state',
      key: 'state',
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const studyYears = await GetStudyYears();
        setDataSource(
          studyYears
            .map((studyYear) => {
              return {
                startDate: formatDate(studyYear.startDate),
                endDate: formatDate(studyYear.endDate),
                state:
                  studyYear.state === 0
                    ? t('studyYear.stateCurrent')
                    : t('studyYear.stateFinished'),
              };
            })
            .sort((a, b) => {
              if (a.state === 'current') {
                return 1;
              }
              return new Date(a.startDate) > new Date(b.startDate) ? 1 : -1;
            })
            .reverse()
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (newStudyYear: ReducedStudyYear) => {
    form.resetFields();
    await UpdateCurrentStudyYear({
      startDate: new Date(newStudyYear.startDate),
      endDate: new Date(newStudyYear.endDate),
    });
    await ArchiveAnnualCollaborationDocuments();

    const fetchData = async () => {
      try {
        const studyYears = await GetStudyYears();
        setDataSource(
          studyYears
            .map((studyYear) => {
              return {
                startDate: formatDate(studyYear.startDate),
                endDate: formatDate(studyYear.endDate),
                state:
                  studyYear.state === 0
                    ? t('studyYear.stateCurrent')
                    : t('studyYear.stateFinished'),
              };
            })
            .sort((a, b) => {
              if (a.state === 'current') {
                return 1;
              }
              return new Date(a.startDate) > new Date(b.startDate) ? 1 : -1;
            })
            .reverse()
        );
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  };

  return (
    <>
      <Table columns={columns} dataSource={dataSource} />
      <Form
        layout="horizontal"
        size="large"
        onFinish={handleSubmit}
        form={form}
      >
        <Row gutter={[16, 0]} style={{ width: '70%' }}>
          <Col flex={1}>
            <Form.Item name={'startDate'} rules={[{ required: true }]}>
              <Input type="date" />
            </Form.Item>
          </Col>
          <Col flex={1}>
            <Form.Item name={'endDate'} rules={[{ required: true }]}>
              <Input type="date" />
            </Form.Item>
          </Col>
        </Row>
        <Row justify="center" style={{ marginTop: '8px' }}>
          <Button type="primary" htmlType="submit">
            {t('studyYear.newStudyYear')}
          </Button>
        </Row>
      </Form>
    </>
  );
};
